<script lang="ts">
  import CountBadge from "../lib/ds/CountBadge.svelte";
  import type { Destination } from '../lib/router';
  import { cn } from '../lib/ui/utils';
  import Icon from '../lib/ds/Icon.svelte';

  let { current, onnavigate, needsYou = 0, onsearch, searchHint, sidebarOpen = true, ontoggle = () => {} }: {
    current: Destination; onnavigate: (d: Destination) => void; needsYou?: number;
    onsearch: () => void; searchHint: string; sidebarOpen?: boolean; ontoggle?: () => void;
  } = $props();
  const destinations: { id: Destination; label: string }[] = [
    { id: 'home', label: 'Home' }, { id: 'workspaces', label: 'Workspaces' },
    { id: 'settings', label: 'Settings' }, { id: 'activity', label: 'Activity' },
  ];
</script>

<header data-shell="top-bar" class="top-bar flex shrink-0 items-center gap-2 border-b border-line bg-panel px-4 py-2">
  <button type="button" aria-label={sidebarOpen ? 'Hide the sidebar' : 'Show the sidebar'} aria-expanded={sidebarOpen} aria-controls={sidebarOpen ? 'workspace-sidebar' : undefined} onclick={ontoggle}
    class="icon-button bg-transparent p-0 text-soft" title={sidebarOpen ? 'Hide the sidebar' : 'Show the sidebar'}>
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d={sidebarOpen ? 'm13 4-6 6 6 6' : 'm7 4 6 6-6 6'} /></svg>
  </button>
  <nav aria-label="Main" class="flex shrink-0 items-center gap-2">
    {#each destinations as d (d.id)}
      <button type="button" data-destination={d.id} aria-current={current === d.id ? 'page' : undefined}
        onpointerdown={(e) => e.preventDefault()} onclick={() => onnavigate(d.id)}
        class={cn('touch-manipulation flex h-11 items-center gap-2 rounded-control bg-transparent px-3 text-base font-semibold text-soft', current === d.id && 'bg-raised text-accent-text')}>
        <Icon name={d.id} size={16} /><span>{d.label}</span>
        {#if d.id === 'workspaces' && needsYou}<CountBadge count={needsYou} label={`${needsYou} need you`} />{/if}
      </button>
    {/each}
  </nav>
  <button type="button" aria-label="Search workspaces and actions" data-palette-trigger onclick={onsearch} class="search-trigger">
    <Icon name="search" size={16} /><span>Search</span><kbd aria-hidden="true">{searchHint}</kbd>
  </button>
</header>

<style>
  .top-bar { min-height: 60px; background: var(--sunken); }
  nav button { font-size: 13px; font-weight: 500; }
  .search-trigger { display: flex; align-items: center; gap: 8px; min-width: 120px; max-width: 320px; min-height: 44px; flex: 1; margin-left: auto; padding: 8px 12px; border: 1px solid var(--line); border-radius: var(--radius-sm); background: var(--bg); color: var(--soft); font-size: 13px; font-weight: 400; }
  .search-trigger kbd { margin-left: auto; font-family: inherit; font-size: 12px; color: var(--muted); }
  @media (max-width: 1000px) { nav :global(svg) { display: none; } .search-trigger { max-width: 240px; } }
</style>
